import { Link } from "react-router-dom";
import { Mail, MapPin, Flame } from "lucide-react";
import { IMG, CONTACT } from "../lib/site";

export const Footer = () => (
  <footer data-testid="site-footer" className="relative border-t border-amber-900/25 bg-[#0a0806]">
    <div className="hairline-gold absolute inset-x-0 top-0" />
    <div className="mx-auto grid max-w-7xl gap-12 px-5 py-16 sm:px-10 md:grid-cols-[1.4fr_1fr_1fr] lg:gap-20">
      <div>
        <div className="flex items-center gap-4">
          <img
            src={IMG.logo}
            alt="Cozy Ember Co. crest"
            className="h-16 w-16 rounded-full border border-amber-500/40 object-cover shadow-ember"
          />
          <div>
            <p className="font-serif text-2xl font-semibold text-stone-50">
              Cozy <span className="text-gold-gradient">Ember</span> Co.
            </p>
            <p className="mt-1 font-mono text-[10px] uppercase tracking-[0.32em] text-amber-500/80">
              Handcrafted Outdoor Luxury · Est. 2024
            </p>
          </div>
        </div>
        <p className="mt-6 max-w-sm text-sm leading-relaxed text-stone-400">
          Bespoke fire tables handcrafted from authentic wine and whiskey barrels, crowned with
          natural stone. Where fire becomes furniture, and craftsmanship becomes conversation.
        </p>
      </div>

      <div>
        <p className="font-mono text-xs uppercase tracking-[0.28em] text-amber-500/90">Explore</p>
        <nav className="mt-5 flex flex-col gap-3 text-sm">
          <Link data-testid="footer-link-collections" to="/collections" className="text-stone-400 transition-colors duration-200 hover:text-amber-400">Collections</Link>
          <Link data-testid="footer-link-gallery" to="/gallery" className="text-stone-400 transition-colors duration-200 hover:text-amber-400">Gallery</Link>
          <Link data-testid="footer-link-configurator" to="/configurator" className="text-stone-400 transition-colors duration-200 hover:text-amber-400">Bespoke Atelier</Link>
          <Link data-testid="footer-link-craftsmanship" to="/craftsmanship" className="text-stone-400 transition-colors duration-200 hover:text-amber-400">Stone & Craft</Link>
          <Link data-testid="footer-link-hospitality" to="/hospitality" className="text-stone-400 transition-colors duration-200 hover:text-amber-400">Hospitality & Trade</Link>
          <Link data-testid="footer-link-contact" to="/contact" className="text-stone-400 transition-colors duration-200 hover:text-amber-400">Private Commission</Link>
        </nav>
      </div>

      <div>
        <p className="font-mono text-xs uppercase tracking-[0.28em] text-amber-500/90">Concierge</p>
        <div className="mt-5 flex flex-col gap-4 text-sm text-stone-400">
          <a href={CONTACT.emailHref} data-testid="footer-email-link" className="flex items-center gap-3 transition-colors duration-200 hover:text-amber-400">
            <Mail size={15} className="shrink-0 text-amber-500" /> {CONTACT.email}
          </a>
          <p className="flex items-center gap-3">
            <MapPin size={15} className="shrink-0 text-amber-500" /> {CONTACT.region}
          </p>
          <p className="flex items-center gap-3">
            <Flame size={15} className="shrink-0 text-amber-500" /> Serving Canada & the United States
          </p>
        </div>
      </div>
    </div>

    <div className="border-t border-stone-900">
      <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-3 px-5 py-6 font-mono text-[11px] uppercase tracking-[0.2em] text-stone-600 sm:flex-row sm:px-10">
        <p>© 2026 Cozy Ember Co. All rights reserved.</p>
        <p>Fire becomes furniture.</p>
      </div>
    </div>
  </footer>
);
